import React, { type HTMLAttributes } from 'react';

import { Block, RecursiveMenu } from '@uncinc/react-drupal-core';
import { Container, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import SocialMenu from '../../Social';
import SoloSearch from '../../../../components/Search/SoloSearch';
import { APP_OPTIONS, SCREEN_MD } from '../../../../config/constants';

import './style.scss';

interface OverlayProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  toggleOverlay: (onlyClose?: boolean) => void;
}

const Overlay: React.FC<OverlayProps> = ({
  toggleOverlay,
}) => {
  const { width } = useWindowDimensions();

  return (
    <div className="HeaderMenu__Overlay">
      <div className="HeaderMenu__Overlay__background">
        <div className="HeaderMenu__Overlay__wrapper">
          <div className="HeaderMenu__Overlay__wrapper__section HeaderMenu__Overlay__top-section">
            <Container>
              <div className="HeaderMenu__Overlay__top-section__wrapper">
                <SoloSearch toggleOverlay={() => toggleOverlay()} />
                {width < SCREEN_MD && (
                  <RecursiveMenu
                    menuId="navigation-actions"
                    maxLevel={1}
                    onClickFunction={() => toggleOverlay(true)}
                  />
                )}
              </div>
            </Container>
          </div>

          <div className="HeaderMenu__Overlay__wrapper__section HeaderMenu__Overlay__main-section">
            <Container>
              <div className="row HeaderMenu__Overlay__main-section__wrapper">
                <div className="col-12 col-lg-3">
                  <div className="HeaderMenu__Overlay__main-section__main-menu">
                    <RecursiveMenu
                      menuId="main"
                      onClickFunction={() => toggleOverlay()}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-6">
                  <div className="HeaderMenu__Overlay__main-section__overlay-menu">
                    <RecursiveMenu
                      menuId="overlay-menu"
                      onClickFunction={() => toggleOverlay()}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-3">
                  <div className="HeaderMenu__Overlay__main-section__contact-block">
                    <Block id={APP_OPTIONS.parameters.contactBlockID} />
                  </div>
                </div>
              </div>
            </Container>
          </div>

          <div className="HeaderMenu__Overlay__wrapper__section HeaderMenu__Overlay__bottom-section">
            <Container>
              <div className="row HeaderMenu__Overlay__bottom-section__wrapper">
                <div className="col-12 col-lg-9">
                  <RecursiveMenu
                    menuId="legal"
                    maxLevel={1}
                    onClickFunction={() => toggleOverlay()}
                  />
                </div>
                <div className="col-12 col-lg-3">
                  <SocialMenu />
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overlay;
